// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Report$ReactHooksTemplate = require("../reports/report.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var EmailContent$ReactHooksTemplate = require("./emailContent.res.js");
var EmailContentItem$ReactHooksTemplate = require("./EmailContentItem.res.js");

var emptyState = {
  loading: false,
  dataFields: /* [] */0,
  emailContents: /* [] */0,
  reports: /* [] */0,
  timeFrames: /* [] */0
};

function EmailContentInfo(props) {
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchDataFields = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                  return Json_decode.field("data_fields", (function (param) {
                                return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  var fetchEmailContents = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/email_content_info", (function (param) {
                  return Json_decode.field("email_content_infos", (function (param) {
                                return Json_decode.list(EmailContent$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  var fetchReports = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/reports", (function (param) {
                  return Json_decode.field("reports", (function (param) {
                                return Json_decode.list(Report$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  var fetchTimeFrames = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/reports/time_frames", (function (param) {
                  return Json_decode.field("time_frames", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }));
  };
  React.useEffect((function (param) {
          Curry._1(setState, (function (s) {
                  return {
                          loading: true,
                          dataFields: s.dataFields,
                          emailContents: s.emailContents,
                          reports: s.reports,
                          timeFrames: s.timeFrames
                        };
                }));
          Js_promise.$$catch((function (_err) {
                  Curry._1(setState, (function (s) {
                          return {
                                  loading: false,
                                  dataFields: s.dataFields,
                                  emailContents: s.emailContents,
                                  reports: s.reports,
                                  timeFrames: s.timeFrames
                                };
                        }));
                  return Promise.resolve();
                }), Js_promise.then_((function (param) {
                      var timeFrames = param[3];
                      var reports = param[2];
                      var emailContentInfos = param[1];
                      var dataFields = param[0];
                      Curry._1(setState, (function (param) {
                              return {
                                      loading: false,
                                      dataFields: dataFields,
                                      emailContents: emailContentInfos,
                                      reports: reports,
                                      timeFrames: timeFrames
                                    };
                            }));
                      return Promise.resolve();
                    }), Promise.all([
                        fetchDataFields(),
                        fetchEmailContents(),
                        fetchReports(),
                        fetchTimeFrames()
                      ])));
        }), []);
  var updateEmailContentAt = function (index, updateFunc) {
    Curry._1(setState, (function (s) {
            var updatedList = List.mapi((function (i, ec) {
                    if (i === index) {
                      return Curry._1(updateFunc, ec);
                    } else {
                      return ec;
                    }
                  }), s.emailContents);
            return {
                    loading: s.loading,
                    dataFields: s.dataFields,
                    emailContents: updatedList,
                    reports: s.reports,
                    timeFrames: s.timeFrames
                  };
          }));
  };
  var deleteEmailContentAt = function (index) {
    Curry._1(setState, (function (s) {
            var updatedList = List.mapi((function (i, x) {
                    if (i === index) {
                      return EmailContent$ReactHooksTemplate.setDeleted(x, true);
                    } else {
                      return x;
                    }
                  }), s.emailContents);
            return {
                    loading: s.loading,
                    dataFields: s.dataFields,
                    emailContents: updatedList,
                    reports: s.reports,
                    timeFrames: s.timeFrames
                  };
          }));
  };
  if (state.loading) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Loading Email Content...",
                                          className: "text-gray-600"
                                        })
                                  ],
                                  className: "flex items-center space-x-3"
                                }),
                            className: "flex items-center justify-center py-20"
                          }),
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    }),
                className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("span", {
                                                        children: "📧",
                                                        className: "text-xl"
                                                      }),
                                                  className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("h1", {
                                                          children: "Email Content Configuration",
                                                          className: "text-2xl font-bold text-gray-900"
                                                        }),
                                                    JsxRuntime.jsx("p", {
                                                          children: "Add subject and body for email templates used in notification rules",
                                                          className: "text-sm text-gray-600 mt-1"
                                                        })
                                                  ]
                                                })
                                          ],
                                          className: "flex items-center space-x-3"
                                        }),
                                    className: "flex items-center justify-between"
                                  }),
                              className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                            }),
                        className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "⚙️",
                                                        className: "text-lg"
                                                      }),
                                                  JsxRuntime.jsx("h2", {
                                                        children: "Email Templates",
                                                        className: "text-lg font-bold text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("span", {
                                                        children: String(List.length(state.emailContents)) + " template(s)",
                                                        className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                      })
                                                ],
                                                className: "flex items-center space-x-2"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                children: "+",
                                                                className: "mr-2"
                                                              }),
                                                          "Add Email Content"
                                                        ],
                                                        className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                        type: "button",
                                                        onClick: (function (param) {
                                                            Curry._1(setState, (function (s) {
                                                                    return {
                                                                            loading: s.loading,
                                                                            dataFields: s.dataFields,
                                                                            emailContents: List.append(s.emailContents, {
                                                                                  hd: EmailContent$ReactHooksTemplate.empty(),
                                                                                  tl: /* [] */0
                                                                                }),
                                                                            reports: s.reports,
                                                                            timeFrames: s.timeFrames
                                                                          };
                                                                  }));
                                                          })
                                                      }),
                                                  JsxRuntime.jsx("button", {
                                                        children: "Save",
                                                        className: "inline-flex items-center px-6 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors duration-200",
                                                        type: "button",
                                                        onClick: (function (param) {
                                                            var emailContents = List.map(EmailContent$ReactHooksTemplate.encode, state.emailContents);
                                                            var params = {};
                                                            params["email_content_infos"] = Json_encode.list((function (x) {
                                                                    return x;
                                                                  }), emailContents);
                                                            Js_promise.$$catch((function (_err) {
                                                                    return Promise.resolve();
                                                                  }), Js_promise.then_((function (response) {
                                                                        var status = Json_decode.field("status", (function (param) {
                                                                                return Json_decode.withDefault("failed", Json_decode.string, param);
                                                                              }), response);
                                                                        if (status === "success") {
                                                                          window.location.reload();
                                                                        }
                                                                        return Promise.resolve();
                                                                      }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_content_info/save", params)));
                                                          })
                                                      })
                                                ],
                                                className: "flex items-center gap-2"
                                              })
                                        ],
                                        className: "flex items-center justify-between"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: "Configure name, subject, body and optional data field placeholders",
                                        className: "text-sm text-gray-600 mt-1"
                                      })
                                ],
                                className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                              }),
                          JsxRuntime.jsx("div", {
                                children: $$Array.of_list(Belt_List.mapWithIndex(state.emailContents, (function (index, emailContent) {
                                            if (EmailContent$ReactHooksTemplate.deleted(emailContent) !== false) {
                                              return null;
                                            }
                                            var xs = EmailContent$ReactHooksTemplate.dataFields(emailContent);
                                            var selectedDataFieldNames = xs !== undefined ? List.map(DataField$ReactHooksTemplate.name, xs) : /* [] */0;
                                            return JsxRuntime.jsx(EmailContentItem$ReactHooksTemplate.make, {
                                                        deleteEmailContentAt: deleteEmailContentAt,
                                                        emailContent: emailContent,
                                                        index: index,
                                                        updateEmailContentAt: updateEmailContentAt,
                                                        dataFields: state.dataFields,
                                                        selectedDataFieldNames: selectedDataFieldNames,
                                                        reports: state.reports,
                                                        timeFrames: state.timeFrames
                                                      });
                                          }))),
                                className: "p-6 flex flex-col gap-4"
                              })
                        ],
                        className: "bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300"
                      })
                ],
                className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
              });
  }
}

var make = EmailContentInfo;

exports.emptyState = emptyState;
exports.make = make;
/* react Not a pure module */
